<template>
  <div class="container mx-auto">
    <CRow class="d-flex">
      <CCol xs="12" sm="12" md="12" lg="12" xxl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;FILTRO</b>
            <CButton type="button" class="btn btn-sm text-white" @click="returnHome" style="background: #E46666">
              <i class="fas fa-hand-point-left"></i> Retroceder
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="6" lg="6" xxl="12">
                <CInput label="Desde" type="date" @input="mtdGetData" v-model="filter.begindate" size="sm" />
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6" xxl="12">
                <CInput label="Hasta" type="date" @input="mtdGetData" v-model="filter.enddate" size="sm" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    <!-- </CRow>
    <CRow> -->
      <CCol xs="12" sm="12" md="12" lg="12" xxl="9">
        <CCard>
          <CCardHeader class="kardex-title">
              CXC
          </CCardHeader>
          <CCardBody>
            <!-- paginado -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center px-1 mb-2">
              <div v-if="cpData.length > 0" class="d-flex justify-content-end">
                <nav aria-label="Page navigation example">
                  <ul class="pagination mb-1">
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="backPage"
                        >Anterior</a
                      >
                    </li>
                    <li
                      v-if="limitedStepPagination[0] !== 1"
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage === 1 ? 'page-link active' : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(1)"
                        >1</a
                      >
                    </li>
                    <li
                      v-if="limitedStepPagination[0] > 2"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="(item, index) in limitedStepPagination"
                      :key="index"
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage === item
                            ? 'page-link active'
                            : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(item)"
                        >{{ item }}
                      </a>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[
                          limitedStepPagination.length - 1
                        ] <
                        stepPagination.length - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[
                          limitedStepPagination.length - 1
                        ] !== stepPagination.length
                      "
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage === limitedStepPagination.length + 2
                            ? 'page-link active'
                            : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(stepPagination.length)"
                        >{{ stepPagination.length }}
                      </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="nextPage"
                        >Siguiente</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <!-- Fin paginado -->
            <div id="content-timelinetable" class="table-responsive">
              <table id="tb-cxc" class="table table-bordered border-main align-middle">
                <thead>
                  <tr class=" text-center" style="vertical-align: middle">
                    <th scope="col" style="vertical-align: middle;">N°</th>
                    <th scope="col" style="vertical-align: middle;">CLIENTE</th>
                    <th scope="col" style="vertical-align: middle;">TOTAL DE VENTA</th>
                    <th scope="col" style="vertical-align: middle;">AMORTIZADO</th>
                    <th scope="col" style="vertical-align: middle;">PENDIENTE</th>
                    <!-- <th scope="col" style="vertical-align: middle;">A PAGAR</th> -->
                    <th scope="col" style="vertical-align: middle;">ESTADO</th>
                    <th scope="col" style="vertical-align: middle;">ACCION</th>
                  </tr>
                </thead>

                <tbody class="custom-table text-center">
                    <tr
                      class="table-body text-center"
                      v-if="cpData.length === 0"
                    >
                        <td colspan="7" class="text-center">No hay Registros</td>
                    </tr>
                    <tr v-for="(item, index) in cpData" :key="index">
                      <td>
                        {{ mtdNumber(index) }}
                      </td>
                      <td>
                        {{ item.client.document }} - {{ item.client.name }}
                      </td>
                      <td>S/{{ item.total_payment}}</td>
                      <td>S/{{ item.amount }}</td>
                      <td class="text-danger">
                        S/{{
                          item.pending < 0
                            ? parseFloat(item.pending * -1).toFixed(2)
                            : parseFloat(item.pending).toFixed(2)
                        }}
                      </td>

                      <!-- <td class="text-warning font-weight-bold">
                          <div v-if="posEditPrice !== item.id" @dblclick="mtdEditField(item.id)">
                              {{ item.payment_amount}}
                          </div>
                          <div v-else>
                              <input type="text" v-model="item.new_payment_amount"
                                  @keyup.enter="mtdSaveEdit(item.id)"
                                  @blur="mtdSaveEdit(item.id)"
                                  @keypress="isNumber($event)"
                                  class="form-control form-control-sm text-center text-warning font-weight-bold"
                                  placeholder="A Pagar" />
                          </div>
                      </td> -->

                      <td>
                        <div class="" v-if="item.pending > 0">
                          <div class="text-danger"><strong>DEBE</strong></div>
                        </div>
                        <div class="" v-else-if="item.pending < 0">
                          <div class="text-success">
                            <strong>DEVOLUCIÓN</strong>
                          </div>
                        </div>
                        <div class="" v-else>
                          <div class="text-success">
                            <strong>-</strong>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-center">
                          <button
                            class="btn btn-sm text-white" style="background: #FFC107; margin-right: 5px"
                            @click="mtdToChange(item)"
                            :disabled="parseFloat(item.new_payment_amount) > parseFloat(item.pending)"
                          >
                            <i class="fas fa-coins"></i>
                          </button>
                          <button v-if="item.payment_status !== 2"
                          class="btn btn-sm text-white" style="background: #39f"
                            @click="mtdEditCarrito(item, index)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <cModalCanjeGarantiaVue
      :title="modalCanje.title"
      :boo_modal="modalCanje.boo_modal"
      :item="modalCanje.item"
      :patient="modalCanje.patient"
      :pending="modalCanje.pending"
      @mtdCloseModalCanje="mtdCloseModalCanje"
      @mtdCommitCanjear="mtdCommitCanjear"
    />
    <cModalEditCarritoVue
      :title="modalEdit.title"
      :boo_modal="modalEdit.boo_modal"
      :item="modalEdit.item"
      @mtdCloseModalEdiatCarrito="mtdCloseModalEdiatCarrito"
      @mtdCommitDelCarrito="mtdCommitDelCarrito"
      @mtdCommitEditQuantity="mtdCommitEditQuantity"
      @mtdCommitEditPrice="mtdCommitEditPrice"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import cModalCanjeGarantiaVue from "../modals/cModalCanjeGarantia.vue";
import cModalEditCarritoVue from "../modals/cModalEditCarrito.vue";
import moment from "moment";
export default {
  name: "c-admision-pages-cxc",
  components: {
    cModalCanjeGarantiaVue,
    cModalEditCarritoVue
  },
  data() {
    return {
      data: [],
      filter: {
        begindate: null,
        enddate: null,
        filter_area_name: "ADMISION",
      },
      disabledChkDoc: true,
      chkDoc: false,
      chkPatiente: {
        document: "",
        fullName: "",
        address: "",
      },
      dataDocumentType: [],
      view: "data",
      swal: null,
      search: "",
      dataShow: [],
      modalRegCancel: {
        title: "",
        modal_form: false,
        data: {
          serie: null,
          number: null,
          motive: null,
          type: null,
        },
      },
      //Pag
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
      /* migracion */
      payment: {
        document: "",
        method: "",
        type: "",
        amount: {
          efectivo: 0,
          tarjeta: 0,
          deposito: 0,
          transferencia: 0,
        },
        pending: 0,
        vuelto: 0,
        payment_patient: null,
        payment_eps: 0,
      },
      sale: {
        id: "",
        patient_id: "",
        total: "",
        pending: "",
        state: "",
      },
      modal: {
        title: "",
        action: "",
        boo_modal: false,
        title: "",
        payload: {},
      },
      posEdit: null,
      noRecordsMessage: "",
      vuelto: false,
      pending: false,
      totalPay: 0.0,
      posEditPeriod: null,
      newAdmissionPeriod: null,
      /** carrito */
      carrito: {
        type_patient: "",
        data: [],
        saleId: null,
        amount: [0, 0, 0],
        insurance: null,
        payment_eps: null,
      },
      /** canje */
      modalCanje: {
        title: "Canjear documento",
        item: [],
        boo_modal: false,
        pending: null,
        bead: null,
        method: null,
        sustento: null,
        patient: null,
        sale: null,
        amount: null,
        new_payment_amount: null
      },
      /** canje */
      modalFechas: {
        title: "Periodo del servicio",
        item: [],
        boo_modal: false,
        date_ind: null,
        date_end: null,
      },
      datePos: 0,
      /** editar carrito */
      modalEdit: {
        title: "Editar Liquidación",
        item: [],
        boo_modal: false,
        pos: null
      },
      /** pdf  */
      doctors: [],
      modalPpdfLiqui: {
        title: "Datos para el pdf de liquidación",
        boo_modal: false,
        doctors: [
          {
            name: "",
            id: "",
          },
        ],
        sale: null
      },
      posEditPrice: null,
    };
  },
  props: {
    bead: {},
  },
  watch: {
    selectPage() {
      this.calculateData(10);
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  created() {
    this.getFirstDayOfMonth();
    this.mtdGetDataComprobantes();
  },
  methods: {
    ...mapActions(["get", "post"]),

    getFirstDayOfMonth: function () {
      const currentDate = new Date();
      const firstDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const today = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      );
      this.filter.begindate = firstDayOfMonth.toISOString().split("T")[0];
      this.filter.enddate = today.toISOString().split("T")[0];
    },
    //Traer Data
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/cxc",
        token: this.$store.getters.get__token,
        params: {
          campu_id: this.$store.getters.get_campu.id,
          init: this.filter.begindate,
          end: this.filter.enddate,
        },
      })
        .then((response) => {
          const filteredData = response.data.data.filter((item) => {
            if (item.voucher && item.voucher.length > 0) {
              return item.voucher[0].state !== 2 || item.type !== "garantia";
            } else {
              return true;
            }
          });
          this.dataShow = [];
          this.selectPage = 1;
          this.data = filteredData;
          this.calculateData(10);
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },

    calculateData(items) {
      if (!this.data || !this.data.length) {
        return (this.dataShow = []);
      }
      let filteredData = this.data;
      let indexInitial = this.selectPage;
      if (this.search.length >= 2 && this.search != "") {
        let query = this.search.toString().toUpperCase();
        filteredData = this.data.filter((element) => {
          let name = element.patient.name.toString().toUpperCase();
          let number = element.patient.document.toString().toUpperCase();
          let serie = element.type.toString().toUpperCase();
          return (
            name.includes(query) ||
            number.includes(query) ||
            serie.includes(query)
          );
        });
        indexInitial = 1;
      }

      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1
      );

      let startIndex = (indexInitial - 1) * items;
      let endIndex = startIndex + (items - 1);
      this.dataShow = filteredData.slice(startIndex, endIndex + 1);
    },

    /* modales y funciones */
    mtdGetDataComprobantes: function () {
      this.post({
        url: this.$store.getters.get__url + "/cxc/filter",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.dataDocumentType = response.data.data;
        })
        .catch((errors) => {});
    },

    /** para canjear documento */
    mtdToChange: function (item) {
      if (item.total_payment > 0) {
        this.modalCanje.total = item.total_payment;
        this.modalCanje.item = item.voucher;
        this.modalCanje.patient = item.client;
        this.modalCanje.boo_modal = true;
        this.modalCanje.pending = item.pending;
        this.modalCanje.bead = this.bead;
        this.modalCanje.sale = item;
        this.modalCanje.new_payment_amount = item.new_payment_amount;
      } else {
        Swal.fire({
          icon: "warning",
          title: "No hay liquidacion del servicio",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    mtdCloseModalCanje: function () {
      this.modalCanje = {
        title: "Canjear documento",
        item: [],
        boo_modal: false,
        pending: null,
        bead: null,
        method: null,
        sustento: null,
        type: null,
        patient: null,
        sale: null,
        amount: null,
        new_payment_amount: null
      };
    },

    mtdCommitCanjear: function (
      method,
      sustento,
      typePago,
      client,
      amount,
      cuotas,
      new_payment_amount
    ) {
      let sus = sustento;
      let dataBead = this.modalCanje.bead ? this.modalCanje.bead.id : null;
      this.modalCanje.sustento = sustento;
      this.modalCanje.method = method;
      this.modalCanje.amount = amount;
        this.post({
          url: this.$store.getters.get__url + "/cxc/canje",
          token: this.$store.getters.get__token,
          params: {
            sale: this.modalCanje.sale.id,
            typePago: typePago,
            client: client,
            method: method,
            bead: dataBead,
            amount: amount,
            new_payment_amount:  new_payment_amount,
            cuotas: cuotas,
            company_id: this.$store.getters.get_company.id,
          },
        })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data != null) {
              if(typePago !== "NOTA DE VENTA") {
                let res = response.data.sunat;
                window.open(res.json.enlace_del_pdf_ticket, "_blank");
              }else{
                  window.open(
                    this.$store.getters.get__url +
                      "/sales/ticket/" + response.data.id + "/" + this.$store.getters.get__user_id,
                      "_blank"
                  );
              }
            }
            this.mtdCloseModalCanje();
            this.mtdGetData();
            Swal.fire({
              title: "Registro Exitoso",
              text: "Perfecto!",
              icon: "success",
              width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          } else {
            Swal.fire({
              title: "Registro Incorrecto",
              text: "Error!",
              icon: "error",
              width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Registro Incorrecto",
            text: errors,
            icon: "error",
            width: "400px",
            confirmButtonColor: "rgb(67,81,122)",
          });
        });
    },

    mtdSendNota: function (voucher) {
      this.get({
        url: this.$store.getters.get__url + "/send/nota/" + voucher,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.json != null) {
              window.open(response.json.enlace_del_pdf_ticket, "_blank");
            }
            Swal.fire({
              title: "Nota de credito Generada",
              text: "Perfecto!",
              icon: "success",
              width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          } else {
            Swal.fire({
              title: "Registro Incorrecto",
              text: "Error!",
              icon: "error",
              width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Registro Incorrecto",
            text: errors,
            icon: "error",
            width: "400px",
            confirmButtonColor: "rgb(67,81,122)",
          });
        });
    },

    /** editar  carrito */
    mtdEditCarrito: function (item, pos) {
      this.modalEdit.item = item.detail;
      this.modalEdit.boo_modal = true;
      this.modalEdit.pos = pos;
    },
    mtdCloseModalEdiatCarrito: function () {
      this.modalEdit = {
        title: "Editar Liquidación",
        item: [],
        boo_modal: false,
        pos: null,
        type_patient: null,
      };
    },
    mtdCommitDelCarrito: function (detId) {
      Swal.fire({
        title: "¿Estás seguro que deseas eliminar este item?",
        // text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        width: "400px",
      }).then((result) => {
        if (result.isConfirmed) {
          this.mtdCommitDel(detId);
        }
      });
    },

    mtdCommitDel: function (detId) {
      this.get({
        url: this.$store.getters.get__url + "/cxc/deletecarrito/" + detId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if(response.data.state == 1){
              Swal.fire({
                title: "No se puede Eliminar",
                text: `Solo se elimina si lo Restante (${response.data.totalDetail}) es Mayor que lo Amortizado (${response.data.amount})`,
                icon: "warning",
              });
            }else {
              let temp = [];
              let del = {};
              this.modalEdit.item.forEach((element) => {
                if (element.id != detId) {
                  temp.push(element);
                } else {
                  del = element;
                }
              });
              this.modalEdit.item = temp;
              this.dataShow[this.modalEdit.pos].detail = temp;
              this.dataShow[this.modalEdit.pos].total =
                parseFloat(this.dataShow[this.modalEdit.pos].total).toFixed(2) -
                parseFloat(del.quantity * del.price).toFixed(2);
              this.dataShow[this.modalEdit.pos].pending =
                parseFloat(this.dataShow[this.modalEdit.pos].pending).toFixed(2) -
                parseFloat(del.quantity * del.price).toFixed(2);
              this.mtdGetData();
            }
          } else {
            Swal.fire({
              title: "Error",
              text: "",
              icon: "error",
              // width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Error",
            text: errors,
            icon: "error",
            // width: "400px",
            confirmButtonColor: "rgb(67,81,122)",
          });
        });
    },
    /** editar cantidad */
    mtdCommitEditQuantity: function (pos, quantity) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/cxc/editquantity/" +
          this.modalEdit.item[pos].id +
          "/" +
          quantity,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            let oldCantidad = parseFloat(this.modalEdit.item[pos].quantity);
            this.modalEdit.item[pos].quantity = quantity;
            let dif =
              parseFloat(this.modalEdit.item[pos].price) *
              (parseFloat(quantity) - parseFloat(oldCantidad));
            let newTotal =
              parseFloat(this.dataShow[this.modalEdit.pos].total) +
              parseFloat(dif);
            let newPending =
              parseFloat(this.dataShow[this.modalEdit.pos].pending) +
              parseFloat(dif);
            this.dataShow[this.modalEdit.pos].total =
              parseFloat(newTotal).toFixed(2);
            this.dataShow[this.modalEdit.pos].pending =
              parseFloat(newPending).toFixed(2);
            Swal.fire({
              title: "Correcto!!",
              text: "Editado correctamente",
              icon: "success",
              // width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "",
              icon: "error",
              // width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Error",
            text: errors,
            icon: "error",
            // width: "400px",
            confirmButtonColor: "rgb(67,81,122)",
          });
        });
    },
    /** editar precio*/
    mtdCommitEditPrice: function (pos, newPrice) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/cxc/editprice/" +
          this.modalEdit.item[pos].id +
          "/" +
          newPrice,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            let oldCantidad = parseFloat(this.modalEdit.item[pos].quantity);
            let oldPrice = parseFloat(this.modalEdit.item[pos].price);
            this.modalEdit.item[pos].price = newPrice;
            let dif = parseFloat(newPrice) - oldPrice;
            let totaldif = dif * oldCantidad;
            let newTotal =
              parseFloat(this.dataShow[this.modalEdit.pos].total) +
              parseFloat(totaldif);
            let newPending =
              parseFloat(this.dataShow[this.modalEdit.pos].pending) +
              parseFloat(totaldif);
            this.dataShow[this.modalEdit.pos].total =
              parseFloat(newTotal).toFixed(2);
            this.dataShow[this.modalEdit.pos].pending =
              parseFloat(newPending).toFixed(2);
            this.mtdGetData();
            Swal.fire({
              title: "Correcto!!",
              text: "Editado correctamente",
              icon: "success",
              confirmButtonColor: "rgb(67,81,122)",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "",
              icon: "error",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: "Error",
            text: errors,
            icon: "error",
            confirmButtonColor: "rgb(67,81,122)",
          });
        });
    },

    //Pago por Partes
    isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    },

    mtdEditField(id) {
        const index = this.cpData.findIndex(item => item.id === id);
        if (index !== -1) {
            this.posEditPrice = id;
            this.cpData[index].new_payment_amount = this.cpData[index].payment_amount;
        }
    },

    mtdSaveEdit(id) {
        const index = this.cpData.findIndex(item => item.id === id);
        if (index !== -1) {
            const newPrice = parseFloat(this.cpData[index].new_payment_amount);
            if (!isNaN(newPrice)) {
                this.cpData[index].payment_amount = newPrice.toFixed(2);
            }
        }
        this.resetEditFields();
    },

    resetEditFields() {
        this.posEditPrice = null;
    },

    //Paginacion
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    mtdNumber: function (index) {
      return (this.selectPage - 1) * 10 + (index + 1);
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatTime(time) {
      let arTime = time.split(":");
      if (arTime[0] <= 12) {
        return time + " am";
      } else {
        return arTime[0] - 12 + ":" + arTime[1] + ":" + arTime[2] + " pm";
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.mtdGetData();
    }, 1000);
  },
};
</script>
<style scoped>
.custom-table th,
.custom-table td {
  font-size: 11px;
  color: black;
}
.bg-white {
  background: #eaf4f4 !important;
}

.table-responsive {
  overflow-x: auto;
}

.kardex-title {
  background-color: #4a5c77;
  color: white;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 3px;
}

.page-link {
  color: #4a5c77 !important;
  border-color: #4a5c77 !important;
}

.page-link:hover {
  background-color: #4a5c77 !important;
  color: white !important;
}

.page-link.active {
  background-color: #4a5c77 !important;
  border-color: #4a5c77 !important;
  color: white !important;
}
</style>

